/**
 * Helper function to find language toggle in content array
 * @param {Array|Object} details - Can be either an array directly or an object with a content property
 * @returns {Object|null} - The language toggle object if found, null otherwise
 */
export const getLanguageToggle = details => {
  if (!details) return null

  // Helper to check if content item is a language toggle
  const isLanguageToggle = content => {
    return (
      content?.__typename === 'Lang' ||
      content?.contentType?.id === 'lang' ||
      content?.contentType?.id === 'Lang'
    )
  }

  // If details is an array, search directly
  if (Array.isArray(details)) {
    return details.find(isLanguageToggle)
  }

  // If details has a content property, search in that
  if (details.content && Array.isArray(details.content)) {
    return details.content.find(isLanguageToggle)
  }

  return null
}
